import { useRouter } from 'next/router';
import { memo } from 'react';

import { LibraryTopBarAddButton } from '~/_app/(library)/l/_components/LibraryTopBarAddButton';
import { GeneralLibraryTopBarAddButton } from '~/_app/(library)/l/general/_components/GeneralLibraryTopBarAddButton';
import { useLibrary } from '~/components/LibraryBeta/hooks/queries/useLibrary';
import { Routes } from '~/constants/routes';
import { useFetchObjectsPermissions } from '~/hooks/useFetchObjectsPermissions';
import { useURLLibraryIdSelector } from '~/hooks/useURLLibraryIdSelector';

export const LibraryActions = memo(() => {
  const libraryId = useURLLibraryIdSelector();
  const { data: library } = useLibrary({ libraryId });
  const { pathname } = useRouter();
  const isGeneralLibrary = pathname === Routes.generalLibrary;

  useFetchObjectsPermissions({
    objects: {
      libraryIds: libraryId ? [libraryId] : [],
    },
  });

  if (isGeneralLibrary) {
    return <GeneralLibraryTopBarAddButton />;
  }

  return libraryId && library ? <LibraryTopBarAddButton library={library} /> : null;
});

LibraryActions.displayName = 'LibraryActions';
